import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Client } from '../../../portfolio/interfaces/client.interface';
import { PromocionesService } from '../../services/promociones.service';

@Component({
  selector: 'app-promo-cliente-form',
  templateUrl: './promo-cliente-form.component.html',
  styleUrls: ['./promo-cliente-form.component.css']
})
export class PromoClienteFormComponent {

  agregarFormCondCliente!: FormGroup;
  clienteTitle: string = '';

  @Input()
  set clienteForm(data: any | undefined) {
    if (data) {
      this.agregarFormCondCliente.patchValue(data);
      this.agregarFormCondCliente.get("id_promo_ant").setValue(data.id_promo);
      this.agregarFormCondCliente.get("id_cliente_ant").setValue(data.id_cliente);
      this.clienteTitle = `${data.id_cliente}-${data.name_cliente}`;
    }
  }

  @Input()
  set idPromo(id: string) {
    this.agregarFormCondCliente.get('id_promo').setValue(id);
  }

  @Input()
  set tipoPromo(tipo: string) {
    this.onChangeTipo(tipo);
  }

  @Input()
  set cliente(cliente: Client | undefined) {
    if (cliente) {
      this.agregarFormCondCliente.get('id_cliente').setValue(cliente.idCliente);
      this.clienteTitle = `${cliente.idCliente}-${cliente.nombreCliente1}`;
    }
  }

  @Output()
  back = new EventEmitter<void>();

  @Output()
  create = new EventEmitter<any>();

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly promocionesService: PromocionesService
  ) {
    this.buildForm();
  }

  private buildForm() {
    this.agregarFormCondCliente = this.formBuilder.group({
      id_promo: ['', []],
      id_promo_ant: ['', []],
      id_cliente: ['', []],
      id_cliente_ant: ['', []],
      name_cliente: ['', []],
      cantidad_maxima: [null, [Validators.min(0)]],
      control_maximo: [null, [Validators.min(0)]],
      numero_maximo_compras: [null, [Validators.required, Validators.min(0)]],
    });
  }

  accionesCondCliente(event: string) {
    if (event === 'guardar') {
      this.create.emit(this.agregarFormCondCliente.getRawValue());
    } else {
      this.back.emit();
    }
  }

  onChangeTipo(tipo: string) {
    this.setALLNoRequiredAndEnable();

    switch (tipo.toString()) {
      case '1':
        break;
      case '2':
        this.setKeyEmptyDisabled('cantidad_maxima');
        break;
      case '7':
        this.setKeyEmptyDisabled('control_maximo');
        this.setKeyEmptyDisabled('numero_maximo_compras');
        break;
      default:
        this.setKeyEmptyDisabled('cantidad_maxima');
        this.setKeyEmptyDisabled('control_maximo');
        this.setKeyEmptyDisabled('numero_maximo_compras');
        break;
    }
  }

  setALLNoRequiredAndEnable() {
    Object.keys(this.agregarFormCondCliente.controls).forEach(key => {
      this.agregarFormCondCliente.get(key).setValidators([]);
      this.agregarFormCondCliente.get(key).updateValueAndValidity();
      this.agregarFormCondCliente.get(key).enable();
    });

    this.agregarFormCondCliente.get('cantidad_maxima').setValidators([Validators.min(0)]);
    this.agregarFormCondCliente.get('cantidad_maxima').updateValueAndValidity();
    this.agregarFormCondCliente.get('control_maximo').setValidators([Validators.min(0)]);
    this.agregarFormCondCliente.get('control_maximo').updateValueAndValidity();
    this.agregarFormCondCliente.get('numero_maximo_compras').setValidators([Validators.required, Validators.min(0)]);
    this.agregarFormCondCliente.get('numero_maximo_compras').updateValueAndValidity();
  }

  setKeyEmptyDisabled(key, value = null) {
    this.agregarFormCondCliente.get(key).setValue(value);
    this.agregarFormCondCliente.get(key).setValidators([]);
    this.agregarFormCondCliente.get(key).updateValueAndValidity();
    this.agregarFormCondCliente.get(key).disable();
  }

}
